import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'removeNewline',
})
export class RemoveNewlinePipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/(\\n|\n)/g, ' ');
  }
}
